(() => {
  const selectors = {
    root: '[data-free-card-banner]',
    headline: '[data-free-card-headline]',
    supporting: '[data-free-card-supporting]',
    badge: '[data-free-card-threshold]'
  };

  const money = (value) => new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    maximumFractionDigits: 0
  }).format(value);

  const updateBanner = (banner, subtotalPence) => {
    const threshold = Number(banner.dataset.threshold || 30);
    const subtotal = Number(subtotalPence || 0) / 100;
    const remaining = Math.max(threshold - subtotal, 0);
    const unlocked = subtotal >= threshold;

    const headline = banner.querySelector(selectors.headline);
    const supporting = banner.querySelector(selectors.supporting);
    const badge = banner.querySelector(selectors.badge);

    banner.dataset.unlocked = unlocked ? 'true' : 'false';

    if (headline) {
      headline.textContent = unlocked
        ? 'You’ve unlocked a free card'
        : subtotal > 0
          ? `Add ${money(remaining)} more to unlock your free card`
          : `Free Card When You Spend ${money(threshold)}`;
    }

    if (supporting) {
      supporting.textContent = unlocked
        ? 'Your basket qualifies for a free Cardology card.'
        : `Spend ${money(threshold)} or more and we’ll include a free card with your order.`;
    }

    if (badge) badge.textContent = money(threshold);
  };

  const refresh = async () => {
    try {
      const response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll(selectors.root).forEach((banner) => updateBanner(banner, cart.items_subtotal_price));
    } catch (_) {}
  };

  document.addEventListener('DOMContentLoaded', refresh, { once: true });
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:change', refresh);
  document.addEventListener('product:added', refresh);
  document.addEventListener('ajaxProduct:added', refresh);
  document.addEventListener('collection:updated', refresh);
})();
